import { render, staticRenderFns } from "./CreateCredentialing.vue?vue&type=template&id=0b1bf0d1&scoped=true&"
import script from "./CreateCredentialing.vue?vue&type=script&lang=js&"
export * from "./CreateCredentialing.vue?vue&type=script&lang=js&"
import style0 from "./CreateCredentialing.vue?vue&type=style&index=0&id=0b1bf0d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1bf0d1",
  null
  
)

export default component.exports